import React, { useState, Fragment } from 'react';
import { Row, Spinner } from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import AriDatePicker from './AriDatePicker';
import AriRoomsTable from './AriRoomsTable';
import moment from 'moment';
import { gAPI_Ari_Room } from '../../../../constants/APIs';
import { AxiosAPI } from '../../../../helpers/AxiosAPI';
import { connect } from 'react-redux';
function Index({ propertyId }) {

  const [roomDate, setRoomDate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(
    moment()
      .add(5, 'days')
      .format('YYYY-MM-DD')
  );
  const getStartDate = date => {
    setStartDate(moment(date).format('YYYY-MM-DD'));
    setEndDate(
      moment(date)
        .add(5, 'days')
        .format('YYYY-MM-DD')
    );
  };
  const handleRoomDataLoad = (startDate, endDate) => {
    setRoomDate([]);
    setLoading(true);
    AxiosAPI({
      methed: 'get',
      url: `${gAPI_Ari_Room}/meeting-rooms?propertyId=${propertyId}&fromDate=${moment(startDate).format('YYYY-MM-DD')}&toDate=${moment(endDate).format('YYYY-MM-DD')}`,
    })
      .then(res => {
        console.log(res.data);
        if (res.data.length === 0) {
          setRoomDate([]);
        } else {
          console.log(res.data);
          setLoading(false);
          setTimeout(() => {
            setRoomDate(res.data);
          }, 1500);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12" className="mb-4">
          <AriDatePicker getStartDate={getStartDate} handleRoomDataLoad={handleRoomDataLoad} />
          {loading ===true ? (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div> 
          ) : (
            <AriRoomsTable roomData={roomDate} startDate={startDate} endDate={endDate} />
            // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
          )}

        </Colxx>
      </Row>

    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, currency } = settings;
  return {
    propertyId,
    currency
  };
};

export default (connect(mapStateToProps, {})(Index));
